import ChatStartButton from 'components/chatting/ChatStartButton';

const Footer = (props) => {
  return (
    <footer style={{...props.footerStyle, zIndex: 1000}}>
      <ChatStartButton />
    </footer>
  )
}
export default Footer